export default "__VITE_ASSET__DQeTCcLs__"